import React, { useState } from "react";
import { Header } from "../Header";
import { Layout } from "./Layout";
import { Sidebar } from "../Sidebar";

export const Activitylogs = () => {
  const [isSidebar, setSidebar] = useState(false);
  return (
    <>
      {isSidebar && <Sidebar />}
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
      >
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                <Layout />
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-results _nghost-dml-c163="" className="ng-star-inserted">
                    <div _ngcontent-dml-c163="" className="right-tab-box">
                      <div
                        _ngcontent-dml-c163=""
                        id="v-pills-tabContent"
                        className="tab-content"
                      >
                        <div
                          _ngcontent-dml-c163=""
                          id="v-pills-results"
                          role="tabpanel"
                          aria-labelledby="v-pills-results-tab"
                          className="tab-pane show active acc-stat-box"
                        >
                          <div
                            _ngcontent-dml-c163=""
                            className="search-table results-table"
                          >
                            <h5 className="head">
                              User Activities{" "}
                              <span
                                _ngcontent-hdd-c162=""
                                className="login-users"
                              >
                                (Last 15 logins)
                              </span>
                            </h5>
                            <div
                              _ngcontent-dml-c163=""
                              className="table-box no-more-tables"
                            >
                              <table
                                _ngcontent-dml-c163=""
                                className="table-borderless"
                              >
                                <thead _ngcontent-dml-c163="">
                                  <tr _ngcontent-dml-c163="">
                                    <th
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                    >
                                      Login Date & Time
                                    </th>
                                    <th
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                    >
                                      Login Status
                                    </th>
                                    <th
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                    >
                                      IP Address
                                    </th>
                                    <th
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                    >
                                      Device Info
                                    </th>
                                    <th
                                      _ngcontent-dml-c163=""
                                      className="text-left"
                                    >
                                      Website
                                    </th>
                                  </tr>
                                </thead>
                                <tbody _ngcontent-dml-c163="">
                                  <tr
                                    _ngcontent-dml-c163=""
                                    className="ng-star-inserted"
                                  >
                                    <td
                                      _ngcontent-dml-c163=""
                                      data-title="Login Date & Time"
                                    >
                                      Test
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      data-title="Login Status"
                                    >
                                      Test
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      data-title="IP Address"
                                    >
                                      Test
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      data-title="Device Info"
                                    >
                                      Test
                                    </td>
                                    <td
                                      _ngcontent-dml-c163=""
                                      data-title="Website"
                                    >
                                      Test
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-results>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};
